import { ApiError, ClinicDetails, ClinicSearchResults } from '@core/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { clinicFeatureKey } from './reducer';
import { State } from './state';

const getClinicSearchResults = (state: State): ClinicSearchResults =>
  state.clinicSearchResults;
const getClinicsLoading = (state: State): boolean => state.clinicsLoading;
const getClinicsError = (state: State): ApiError => state.clinicsError;
const getClinicDetails = (state: State): ClinicDetails => state.clinicDetails;
const getClinicDetailsLoading = (state: State): boolean =>
  state.clinicDetailsLoading;
const getClinicDetailsError = (state: State): ApiError =>
  state.clinicDetailsError;
const getSearchAddress = (state: State): string => state.searchAddress;

export const clinicState = createFeatureSelector<State>(clinicFeatureKey);

export const selectClinicSearchResults = createSelector(
  clinicState,
  getClinicSearchResults,
);
export const selectClinicsLoading = createSelector(
  clinicState,
  getClinicsLoading,
);
export const selectClinicsError = createSelector(clinicState, getClinicsError);

export const selectClinicDetails = createSelector(
  clinicState,
  getClinicDetails,
);
export const selectClinicDetailsLoading = createSelector(
  clinicState,
  getClinicDetailsLoading,
);
export const selectClinicDetailsError = createSelector(
  clinicState,
  getClinicDetailsError,
);

export const selectGetSearchAddress = createSelector(
  clinicState,
  getSearchAddress,
);
